import goalcardService from 'api/goalcard';

const handleError = (error) => {
  let result = error;

  if (typeof error.json === 'function') {
    error.json()
      .then((errorJson) => {
        result = errorJson;
      })
      .catch(() => {
        result = error;
      });
  } else {
    result = error;
  }

  return result;
};

export default {
  getGoalcard: (goalcardId) => (dispatch) => (
    new Promise((resolve, reject) => {
      dispatch({ type: 'GET_GOALCARD' });

      goalcardService.getGoalcard(goalcardId)
        .then((response) => {
          response.json()
            .then((responseJson) => {
              dispatch({ type: 'GET_GOALCARD_SUCCESS', data: responseJson });
              resolve(responseJson);
            });
        })
        .catch((error) => {
          const errorInfo = handleError(error);

          dispatch({ type: 'GET_GOALCARD_FAIL', error: errorInfo });
          reject(errorInfo);
        });
    })
  ),
  getAffiliateGoalcard: (affiliateCode) => (dispatch) => (
    new Promise((resolve, reject) => {
      dispatch({ type: 'GET_GOALCARD_AFFILIATE' });

      goalcardService.getAffiliateGoalcard(affiliateCode)
        .then((response) => {
          response.json()
            .then((responseJson) => {
              dispatch({ type: 'GET_GOALCARD_SUCCESS', data: responseJson });
              resolve(responseJson);
            });
        })
        .catch((error) => {
          const errorInfo = handleError(error);

          dispatch({ type: 'GET_GOALCARD_FAIL', error: errorInfo });
          reject(errorInfo);
        });
    })
  ),
  getContactAffiliateGoalcard: (contactAffiliateCode) => (dispatch) => (
    new Promise((resolve, reject) => {
      dispatch({ type: 'GET_GOALCARD_AFFILIATE' });

      goalcardService.getContactAffiliateGoalcard(contactAffiliateCode)
        .then((response) => {
          response.json()
            .then((responseJson) => {
              dispatch({ type: 'GET_GOALCARD_SUCCESS', data: responseJson });
              resolve(responseJson);
            });
        })
        .catch((error) => {
          const errorInfo = handleError(error);

          dispatch({ type: 'GET_GOALCARD_FAIL', error: errorInfo });
          reject(errorInfo);
        });
    })
  ),
};
